import { useNavigate, useParams } from "react-router-dom"
import useTargetStorage from "@/hooks/useTargetStorage"
import EditLocationForm from "features/storages/locations/editLocationForm"
import { useTranslation } from "react-i18next"
import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import RightSidebarLocation from "components/sidebar/right/RightSidebarLocation"
import PageTitle from "features/navigation/pageTitle"
import useLocations from "hooks/useLocations"
import useStorages from "hooks/useStorages"
import { paramGuardStorage, paramGuardLocation } from "@/utils/paramGuard"

const EditLocation = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()

    const { targetStorageDocId: storageId } = useTargetStorage()
    const { locationId } = useParams<{ locationId: string }>()

    const { 
        location,
        locationStatus 
    } = useLocations({ storageId, locationId })
    const { 
        storage,
        storageStatus 
    } = useStorages({ storageId })

    if (
        !paramGuardStorage({storageId, storage, storageStatus, navigate}) ||
        !paramGuardLocation({storageId, locationId, location, locationStatus, navigate})
    ) {
        return <></>
    }
    const safeStorageId = storageId!;
    const safeLocationId = locationId!;

    return (
        <>
            <PageTitle title={t('titleEditLocation')} />
            <EditLocationForm storageId={safeStorageId} locationId={safeLocationId} />
            <RightSidebarLocation locationId={safeLocationId} storageId={safeStorageId} />
        </>
    )
}

export default EditLocation
